<template>
  <div
    class="sticky-bar"
    :class="{ 'sticky-visible': isSticky }"
  >
    <div class="sticky-bar-content">
      <transition name="section-slide">
        <div v-if="showSection1" class="sticky-bar-section">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <b-avatar
                class="mr-1"
                :variant="productTypeIconColor"
                size="35"
                rounded="lg"
              >
                <feather-icon
                  size="20"
                  :icon="productTypeIcon"
                />
              </b-avatar>
              <h5 class="mb-0 product-title-clickable" @click="scrollToTop">{{ reportTitle }}</h5>
            </div>
            <product-pdf-buttons
              :product-state="productState"
              :is-generating-pdf="isGeneratingPdf"
              @generate-pdf="$emit('generate-pdf', $event)"
            />
          </div>
        </div>
      </transition>
      <transition name="divider-fade">
        <div v-if="showSection1 && showSection2" class="sticky-bar-divider" />
      </transition>
      <transition name="section-slide">
        <div v-if="showSection2" class="sticky-bar-section">
          <product-breakdown-nav :in-sticky-bar="true" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'
import ProductBreakdownNav from './ProductBreakdownNav.vue'
import ProductPdfButtons from './ProductPdfButtons.vue'

export default {
  components: {
    BAvatar,
    ProductBreakdownNav,
    ProductPdfButtons,
  },
  props: {
    reportTitle: {
      type: String,
      default: '',
    },
    productTypeIcon: {
      type: String,
      default: 'BoxIcon',
    },
    productTypeIconColor: {
      type: String,
      default: 'light-primary',
    },
    productState: {
      type: String,
      default: 'current',
    },
    reportNumber: {
      type: [String, Number],
      default: '',
    },
    isGeneratingPdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSection1: false,
      showSection2: false,
    }
  },
  computed: {
    isSticky() {
      return this.showSection1 || this.showSection2
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const reportTitle = document.getElementById('report-title')
      const staticNavBar = document.getElementById('static-nav-bar')

      if (reportTitle) {
        const reportTitleBottom = reportTitle.getBoundingClientRect().bottom
        this.showSection1 = reportTitleBottom < 0
      }

      if (staticNavBar) {
        const staticNavBarBottom = staticNavBar.getBoundingClientRect().bottom
        this.showSection2 = staticNavBarBottom < 0
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style scoped>
.product-title-clickable {
  cursor: pointer;
  transition: color 0.2s ease;
}

.product-title-clickable:hover {
  color: #1a73e8;
}

.sticky-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: white;
  border-bottom: 2px solid #ebe9f1;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateY(-100%);
  opacity: 0;
}

.sticky-bar.sticky-visible {
  transform: translateY(0);
  opacity: 1;
}

.sticky-bar-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sticky-bar-section {
  width: 100%;
  padding: 0.75rem 2rem;
}

.sticky-bar-divider {
  width: 100%;
  height: 1px;
  background-color: #ebe9f1;
}

/* Dark mode support */
.dark-layout .sticky-bar {
  background-color: #283046;
  border-bottom: 2px solid #3b4253;
}

.dark-layout .sticky-bar-divider {
  background-color: #3b4253;
}

/* Section slide transitions */
.section-slide-enter-active,
.section-slide-leave-active {
  transition: all 0.3s ease;
}

.section-slide-enter {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.section-slide-enter-to {
  max-height: 200px;
  opacity: 1;
}

.section-slide-leave {
  max-height: 200px;
  opacity: 1;
}

.section-slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Divider fade transition */
.divider-fade-enter-active,
.divider-fade-leave-active {
  transition: opacity 0.3s ease;
}

.divider-fade-enter,
.divider-fade-leave-to {
  opacity: 0;
}
</style>
